import React, { useState, useEffect } from 'react';
import './index.css';
import '../Referral/Referral.css';
import { IoEyeOutline, IoSearchOutline } from 'react-icons/io5';
import axios from 'axios';
import { useLocation } from 'react-router-dom';
import Loader from '../../components/Loader/Loader';
import UserDetailModal from './UserDetailModal';

export default function ReferralList() {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState('invest');
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedUserWallet, setSelectedUserWallet] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const wallet = params.get('walletAddress');
    if (wallet) setSelectedUserWallet(wallet);
  }, [location]);

  const [pagination, setPagination] = useState({
    limit: 5,
    current: 1,
    totalResults: 0,
    totalPages: 0,
  });

  const environment = process.env.REACT_APP_ENVIRONMENT || 'development';
  const BASE_URL =
    environment === 'production'
      ? process.env.REACT_APP_PROD_API_URL
      : environment === 'staging'
        ? process.env.REACT_APP_STAG_API_URL
        : process.env.REACT_APP_DEV_API_URL || 'http://localhost:4001';

  const fetchData = async () => {
    setLoading(true);
    try {
      const headers = { Authorization: `Bearer ${localStorage.getItem('acessToken')}` };
      const endpoint =
        activeTab === 'invest'
          ? `${BASE_URL}/v1/validator-delegator/referral-list`
          : `${BASE_URL}/v1/validator-delegator/affiliate-earn`;

      const listRes = await axios.get(endpoint, {
        params: { page: pagination.current, limit: pagination.limit },
        headers,
      });

      setUsers(listRes.data.data.results);
      setPagination((prev) => ({
        ...prev,
        totalResults: listRes.data.data.totalResults,
        totalPages: listRes.data.data.totalPages,
      }));
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [pagination.current, activeTab]);

  const handleTabChange = (tab) => {
    if (tab === activeTab) return;
    setActiveTab(tab);
    setSearchTerm('');
    setUsers([]);
    setPagination({ limit: 5, current: 1, totalResults: 0, totalPages: 0 });
  };

  const handlePageNumber = (newPage) => {
    setPagination((prev) => ({ ...prev, current: newPage }));
  };

  const handleSearch = (e) => setSearchTerm(e.target.value);

  const filteredUsers = users.filter(user => {
    const term = searchTerm.toLowerCase();

    if (activeTab === 'invest') {
      return (
        user.walletAddress?.toLowerCase().includes(term) ||
        user.username?.toLowerCase().includes(term) ||
        user.referral_code?.toLowerCase().includes(term)
      );
    }

    if (activeTab === 'affiliate') {
      return (
        user.walletAddress?.toLowerCase().includes(term) ||
        user.txn_hash?.toLowerCase().includes(term) ||
        String(user.amount)?.includes(term)
      );
    }

    return true;
  });

  return (
    <>
      <div className="referral_container">
        <div className="referralTable">

          <div style={{
            display: 'flex',
            gap: '8px',
            padding: '4px',
            background: '#e8f0fe',
            borderRadius: '10px',
            width: 'fit-content',
            marginBottom: '24px',
          }}>
            {[
              { key: 'invest', label: 'Invest Referral List' },
              { key: 'affiliate', label: 'Claim Stake' },
            ].map((tab) => {
              const isActive = activeTab === tab.key;
              return (
                <button
                  key={tab.key}
                  onClick={() => handleTabChange(tab.key)}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    padding: '9px 20px',
                    border: isActive ? '0.5px solid #e2e8f0' : 'none',
                    background: isActive ? '#0d6efd90' : 'transparent',
                    borderRadius: '8px',
                    fontSize: '14px',
                    fontWeight: isActive ? 700 : 600,
                    color: isActive ? '#fff' : '#64748b',
                    cursor: 'pointer',
                    whiteSpace: 'nowrap',
                  }}
                >
                  {tab.label}
                </button>
              );
            })}
          </div>

          <div className="d-flex justify-content-between flex-wrap gap-2 align-items-center mb-3">
            <h4>{activeTab === 'invest' ? 'Invest Referral List' : 'Claim Stake'}</h4>
            <div
              className="d-flex align-items-center bg-white border rounded-2 px-2 py-1 shadow-sm"
              style={{ minWidth: '300px' }}
            >
              <IoSearchOutline className="text-muted me-2" />
              <input
                type="text"
                className="border-0 w-100 py-2"
                placeholder={
                  activeTab === 'invest'
                    ? 'Search by wallet, name or code...'
                    : 'Search by wallet, hash or amount...'
                }
                style={{ outline: 'none', fontSize: '14px' }}
                value={searchTerm}
                onChange={handleSearch}
              />
            </div>
          </div>

          <div className="w-100 responsiveTableParent">
            <table className="w-100">
              <thead className="affTableHeader">
                {activeTab === 'invest' ? (
                  <tr>
                    <th className="boder-Rght">Join Date</th>
                    <th className="boder-Rght">Username</th>
                    <th className="boder-Rght">Wallet Address</th>
                    <th className="boder-Rght">My Code</th>
                    <th className="boder-Rght">Referrer</th>
                    <th className="boder-Rght text-center">Level</th>
                    <th className="boder-Rght">View</th>
                  </tr>
                ) : (
                  <tr>
                    <th className="boder-Rght">Date & Time</th>
                    <th className="boder-Rght">Wallet Address</th>
                    <th className="boder-Rght">Amount</th>
                    <th className="boder-Rght">Txn Hash</th>
                  </tr>
                )}
              </thead>
              <tbody className="referralTableBody">
                {loading ? (  
                  <tr>
                    <td colSpan="7" className="text-center py-5">
                      <Loader />
                    </td>
                  </tr>
                ) : filteredUsers?.length > 0 ? (
                  filteredUsers.map((data, index) =>
                    activeTab === 'invest' ? (
                      <tr key={index}>
                        <td>{new Date(data?.createdAt).toLocaleDateString()}</td>
                        <td className="fw-bold text-primary">{data?.username}</td>
                        <td>
                          <span className="small font-monospace">
                            {data?.walletAddress?.slice(0, 10)}...{data?.walletAddress?.slice(-8)}
                          </span>
                        </td>
                        <td>
                          <span className="badge bg-light text-dark border">{data?.referral_code}</span>
                        </td>
                        <td>{data?.referCodeBy || <span className="text-muted small">Organic</span>}</td>
                        <td className="text-center">
                          <span className={`badge ${data?.level === 0 ? 'bg-success' : 'bg-info'} rounded-pill`}>
                            Level {data?.level}
                          </span>
                        </td>
                        <td>
                          <span onClick={() => setSelectedUserWallet(data.walletAddress)} className="cursor-pointer">
                            <IoEyeOutline fontSize={20} />
                          </span>
                        </td>
                      </tr>
                    ) : (
                      <tr key={index}>
                        <td>{new Date(data?.date_time).toLocaleString()}</td>
                        <td>
                          <span className="small font-monospace">
                            {data?.walletAddress?.slice(0, 10)}...{data?.walletAddress?.slice(-8)}
                          </span>
                        </td>
                        <td className="fw-bold text-success">${data?.amount}</td>
                        <td>
                          <span className="small font-monospace">
                            {data?.txn_hash?.slice(0, 10)}...{data?.txn_hash?.slice(-8)}
                          </span>
                        </td>
                      </tr>
                    )
                  )
                ) : (
                  <tr>
                    <td colSpan="7" className="data_not fw-bold">No Data Found</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <div className="w-100 d-flex justify-content-between mt-3">
            <span className="fw-bold small">
              Showing page {pagination.current} of {pagination.totalPages || 1} ({pagination.totalResults} total)
            </span>
            <div className="AffTxTableButton">
              <button disabled={pagination.current === 1} onClick={() => handlePageNumber(pagination.current - 1)}>
                <span>Prev</span>
              </button>
              {(() => {
                const total = pagination.totalPages;
                const current = pagination.current;
                let start = Math.max(1, current - 2);
                let end = Math.min(total, start + 4);
                if (end - start < 4) start = Math.max(1, end - 4);
                const pages = [];
                for (let i = start; i <= end; i++) pages.push(i);
                return pages.map((page) => (
                  <button
                    className={`${pagination.current === page && 'activePaginationbtn'}`}
                    key={page}
                    onClick={() => handlePageNumber(page)}
                  >
                    {page}
                  </button>
                ));
              })()}
              <button
                disabled={pagination.current === pagination.totalPages || pagination.totalPages === 0}
                onClick={() => handlePageNumber(pagination.current + 1)}
              >
                <span>Next</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <UserDetailModal walletAddress={selectedUserWallet} onClose={() => setSelectedUserWallet(null)} />
    </>
  );
}